module.exports = __webpack_public_path__ + "static/media/horizontal-full color-01.c46201e5.png";